import React, { ReactNode } from 'react';

import Button, { ButtonProps } from '@/src/components/common/Elements/Button/Button';
import { cn } from '@/src/util/ui';

type TooltipProps = {
  content: ReactNode;
  className?: string;
  place?: string;
};

interface ActionButtonProps extends Omit<ButtonProps, 'onClick'> {
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  id?: string;
  isActive?: boolean;
  buttonType?: string;
  tooltipSettings?: TooltipProps;
  onClick?: (e: React.MouseEvent) => void;
}

const ActionButton = ({
  disabled,
  className,
  id,
  isActive,
  buttonType,
  tooltipSettings,
  children,
  onClick = () => {},
  ...otherProps
}: ActionButtonProps) => {
  const buttonClassSettings = {
    variant: buttonType ? buttonType : 'filled_inverse',
    weight: 'bold',
    position: 'center',
    ...(isActive && {
      isActive: isActive,
      activeStyles: cn(
        'tw-rounded-[5px]',
        'tw-text-white tw-border-cfo-blue-700 tw-bg-cfo-blue-700'
      ),
    }),
  };

  return (
    <Button
      id={id}
      className={cn('tw-py-[6px] tw-px-[10px]', className)}
      buttonClassSettings={buttonClassSettings}
      tooltip={tooltipSettings}
      disabled={disabled}
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </Button>
  );
};

export default ActionButton;
